import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PrivateService } from 'app/core/services/private.service';
import { EmployeeTimeSheet } from 'app/shared/models/employeeTimeSheet';

@Component({
  selector: 'dialog-employee-timesheet',
  templateUrl: './dialog-employee-timesheet.component.html',
  styleUrls: ['./dialog-employee-timesheet.component.scss']
})
export class DialogEmployeeTimesheetComponent implements OnInit, AfterViewInit {

  employeeTimeSheet: EmployeeTimeSheet[] = [];
  displayedColumns: string[] = ['timeSheetDate', 'branch', 'ramp_Time1', 'ramp_Time2', 'note1', 'note2', 'submitted'];
  dataSource: MatTableDataSource<EmployeeTimeSheet>;
  expandedNotes: { [key: string]: boolean } = {};

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(public dialogRef: MatDialogRef<DialogEmployeeTimesheetComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private privateService: PrivateService) { }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    this.dataSource = new MatTableDataSource(this.data.employeeTimeSheet);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  toggleNote(key: string): void {
    this.expandedNotes[key] = !this.expandedNotes[key];
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  formatTime(time: string): string {
    if (!time) return '';

    const [hour, minute, second] = time.split(':').map(Number);
    const suffix = hour >= 12 ? 'PM' : 'AM';
    const hour12 = hour % 12 || 12;

    const formattedHour = hour12.toString().padStart(2, '0');
    const formattedMinute = minute.toString().padStart(2, '0');
    const formattedSecond = second.toString().padStart(2, '0');

    return `${formattedHour}:${formattedMinute}:${formattedSecond} ${suffix}`;
  }
}
